/**
 * 司机管理
 */

export default [
  {
    path: 'driver/manage',
    name: '司机管理',
    component: () => import (`@/views/driver/index.vue`),
  },
  {
    path: 'driver/detail',
    name: '司机详情',
    component: () => import ( `@/views/driver/detail`),
  },
];

